import AsyncStorage from '@react-native-async-storage/async-storage';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Dimensions, Image, StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import FilledButton from '../../components/FilledButton';
import MyScrollView from '../../components/MyScrollView';
import PtfKeyboardAvoidingView from '../../components/PtfKeyboardAvoidingView';
import Header from '../../components/register/Header';
import PasswordField from '../../components/register/PasswordField';
import Colors from '../../constants/Colors';
import Languages from '../../constants/Languages';
import Layout from '../../constants/Layout';
import * as Actions from '../../store/Actions';

import { AppText } from '../../components/AppText';

const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.mediumBlue,
  },
  mainContentContainer: {
    alignItems: 'center',
    backgroundColor: Colors.white,
  },
  topContainer: {
    alignItems: 'center',
    marginBottom: 24,
  },
  passwordInfoContainer: {
    width: 328,
    marginTop: Layout.isSmall ? 40 : 50,
    padding: 12,
    alignItems: 'center',
    borderRadius: 4,
    backgroundColor: Colors.lightBlack,
  },
  passwordInfoText: {
    color: Colors.white,
    fontSize: 12,
    fontWeight: '600',
    lineHeight: 16,
    letterSpacing: -0.408,
  },
  passwordContainer: {
    width: 328,
    marginTop: Layout.isSmall ? 40 : 50,
  },
  headingText: {
    fontSize: Layout.isSmall ? 20 : 26,
    fontWeight: '500',
    color: Colors.veryDarkGray,
    fontFamily: 'roboto-regular',
    textAlign: 'center',
    marginTop: Layout.isSmall ? 53 : 34,
  },
  text: {
    fontFamily: 'roboto-regular',
    fontSize: Layout.isSmall ? 20 : 26,
    color: Colors.veryDarkGray,
    textAlign: 'center',
    marginTop: 50,
    width: Layout.isSmall ? 225 : 500,
  },
  image: {
    height: 101,
    width: 69,
    resizeMode: 'contain',
    marginTop: Layout.isSmall ? 33 : 79,
    marginLeft: -10,
  },
  signupContainer: Layout.signupContainer,
  signupFooter: {
    ...Layout.signupFooter,
  },
  linkContainer: {
    paddingHorizontal: 16,
    paddingTop: Layout.isSmall ? 20 : 32,
    paddingBottom: 6,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: Layout.isSmall ? 'row' : 'column',
  },
  magicLinkButton: {
    width: 328,
    alignItems: 'center',
    marginTop: 12,
  },
  linkText: {
    fontSize: Layout.isSmall ? 10 : 16,
    marginTop: 12,
    marginBottom: 12,
    color: Colors.darkGreen,
    textDecorationLine: 'underline',
    textTransform: 'uppercase',
    fontWeight: '500',
  },
  linkSeparator: {
    fontSize: Layout.isSmall ? 14 : 16,
    marginBottom: 24,
    color: Colors.darkGreen,
    fontWeight: '500',
    paddingHorizontal: 10,
  },
});

class EnterPasswordScreen extends Component {
  static propTypes = {
    registration: PropTypes.objectOf(PropTypes.any).isRequired,
    actions: PropTypes.objectOf(PropTypes.any).isRequired,
    navigation: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  constructor(_props) {
    super();
    this.state = {
      password: '',
      isValid: false,
    };
  }

  goBack = () => {
    const { navigation } = this.props;
    navigation.navigate('Language');
  };

  goNext = () => {
    const { actions, registration, navigation } = this.props;
    const { language } = registration;
    const { password } = this.state;
    let email = null;
    if (get(registration, 'emailOrPhoneResult.email')) {
      email = registration.emailOrPhoneResult.email;
    } else if (get(registration, 'enterEmail.results.email')) {
      email = registration.enterEmail.results.email;
    }
    actions.enterPassword(email, password, language, (user) => {
      if (!user.phone && !user.skip_phone_ask) {
        navigation.navigate('EnterPhone');
      } else if (user.docs && user.docs.length) {
        navigation.navigate('TermsPrivacy');
      } else if (!user.onboarding_complete) {
        navigation.navigate('UserDetails');
      } else {
        AsyncStorage.setItem('onboarded', '1').then(() => {
          actions.refreshRedux();
          navigation.navigate('a');
        });
      }
    });
  };

  sendMagicLink = () => {
    const { actions, registration, navigation } = this.props;
    const { language } = registration;
    const translation = Languages.translations[language?.name || 'en'];
    // TODO: Get whereever phone and SMS are
    let email = null;
    if (get(registration, 'emailOrPhoneResult.email')) {
      email = registration.emailOrPhoneResult.email;
    } else if (get(registration, 'enterEmail.results.email')) {
      email = registration.enterEmail.results.email;
    }

    actions.sendMagicLink(email, 'email', language.name, () => {
      // TODO: Send to Magic Link successfully sent Page
      window.alert(translation.magic_link_sent);
    });
  };

  onUpdateText = (params) => {
    const { registration, actions } = this.props;
    const { error } = registration;
    this.setState({
      password: params.password,
      isValid: params.isValid,
    });
    if (error) {
      actions.clearError();
    }
  };

  goToAnotherWay = () => {
    const { navigation } = this.props;
    navigation.navigate('PhoneOrEmail');
  };

  goToResetPassword = () => {
    const { navigation } = this.props;
    navigation.navigate('ResetPassword');
  };

  render() {
    const { registration } = this.props;
    const { error } = registration;
    const { isValid } = this.state;
    const { language } = registration;
    const translation = Languages.translations[language?.name || 'en'];

    return (
      <SafeAreaView style={{ flex: 1 }} edges={['top', 'left', 'right', 'bottom']}>
        <PtfKeyboardAvoidingView style={{ flex: 1 }}>
          <MyScrollView
            contentContainerStyle={styles.mainContentContainer}
            containerStyle={styles.container}
            testID="enter-password"
          >
            <Header title={translation.sign_in} goBack={this.goBack} />
            <View style={styles.signupContainer}>
              <View style={styles.topContainer}>
                <Image source={require('../../assets/images/sign_up/image_36.png')} style={styles.image} />
                <AppText style={styles.text}>{translation.enter_password}</AppText>
                <View style={styles.passwordInfoContainer}>
                  <AppText style={styles.passwordInfoText}>{translation.password_info_box}</AppText>
                </View>
                <View style={styles.passwordContainer}>
                  <PasswordField
                    onTextChange={this.onUpdateText}
                    translation={translation}
                    createPassword={false}
                    error={Boolean(error)}
                  />
                </View>
              </View>
              <View style={styles.signupFooter}>
                <FilledButton
                  onPress={this.goNext}
                  label={translation.submit}
                  color={Colors.primaryColor}
                  full
                  textColor={Colors.white}
                  disabled={!isValid}
                  testID="button-submit"
                />

                <View style={styles.magicLinkButton}>
                  <FilledButton
                    onPress={this.sendMagicLink}
                    label={translation.send_magic_link}
                    color={Colors.primaryColor}
                    full
                    textColor={Colors.white}
                    testID="button-submit"
                  />
                </View>

                <View style={styles.linkContainer}>
                  <AppText onPress={this.goToResetPassword} style={styles.linkText} testID="link-reset">
                    {translation.reset_password}
                  </AppText>
                  {Layout.isSmall ? <AppText style={styles.linkSeparator}>{'•'}</AppText> : null}
                  <AppText onPress={this.goToAnotherWay} style={styles.linkText}>
                    {translation.sign_in_another_way}
                  </AppText>
                </View>
              </View>
            </View>
          </MyScrollView>
        </PtfKeyboardAvoidingView>
      </SafeAreaView>
    );
  }
}

function mapStateToProps(state) {
  return {
    registration: state.registration,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EnterPasswordScreen);
